import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Configuration } from 'src/app/models/configuration';
import { Country } from 'src/app/models/country';
import { Quotation } from 'src/app/models/quotation';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CountriesService } from 'src/app/services/countries.service';
import { EventService } from 'src/app/services/event.service';
import { MainService } from 'src/app/services/main.service';
import { QuotationService } from 'src/app/services/quotation.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { Utils } from 'src/app/services/utils';

@Component({
  selector: 'app-quotation-request',
  templateUrl: './quotation-request.component.html',
  styleUrls: ['./quotation-request.component.scss']
})
export class QuotationRequestComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute,
    private eventService: EventService,
    private userDataService: UserDataService,
    private quotationService: QuotationService,
    private utils: Utils,
    private configurationsService: ConfigurationService,
    private mainService: MainService,
    private translate: TranslateService,
    private countriesService: CountriesService) { }

  clickFirst = false;
  clickSecond = false;
  firstName: string;
  lastName: string;
  email: string;
  colorCap: string;
  colorBottle: string;
  colorCapName: string;
  colorBottleName: string;
  colorValveName: string;
  capacity: number;
  quantity: number;
  images = [];
  filesToUpload = [];
  quotationModel: Quotation;
  configurationModel: Configuration;
  configurationId: number;
  status = false;
  user: any;
  bottleURL: any;
  capName = '';
  valveName = '';

  formIsCompany = true;
  disclaimer = false;
  countries: [Country] = [
    {
      id: "",
      code: "",
      name: "Select a country"
    }
  ];
  usage_type = "0";
  country = "";
  delivery_country = "";

  ngOnInit(): void {
    this.bottleURL = null;
    this.configurationModel = {};
    this.quotationModel = {
      notes: null,
      different_delivery_address: false,
      usage_type: 1
    };
    this.countriesService.getCountries().then(response => {
      this.countries.push(...response.records);
      this.getLastQuotation();
    });
    this.userDataService.checkUser().then(user => {
      this.quotationModel.email = user.email;
    });
    this.route.queryParams.subscribe(params => {
      this.status = params.config;
      this.configurationId = params.id;
    });
    this.filesToUpload = [];
    this.configurationModel.images = [];
    this.quotationService.colorCap.subscribe(color => this.configurationModel.cap_color_hex = color);
    this.quotationService.colorBottle.subscribe(color => this.configurationModel.water_bottle_color_hex = color);
    this.quotationService.colorValve.subscribe(color => this.configurationModel.valve_color_hex = color);
    this.quotationService.capacity.subscribe(capacity => this.configurationModel.water_bottle_capacity = capacity);
    this.quotationService.quantity.subscribe(quantity => this.configurationModel.quantity = quantity);
    this.quotationService.price.subscribe(price => this.configurationModel.price = price);
    this.quotationService.capId.subscribe(id => {
      this.configurationModel.cap_id = id;
      this.mainService.getCap(id).then(cap => {
        const capName = this.translate.instant('color_cap', {cap: this.utils.getTextForKey(cap.texts, 'cap', 'name')});
        this.capName = capName.substr(0, 1).toUpperCase() + capName.substring(1).toLowerCase();
        const valveName = this.translate.instant('color_valve', {valve: this.utils.getTextForKey(cap.texts, 'valve', 'name')});
        this.valveName = valveName.substr(0, 1).toUpperCase() + valveName.substring(1).toLowerCase();
      }).catch(error => {
        this.eventService.hideSpinner();
      });
    });
    this.quotationService.bottleId.subscribe(id => {
      if (id === 0) {
        //this.router.navigate(['/home']);
      } else {
        this.configurationModel.water_bottle_id = id;
      }
    });
    let array = [];
    let img = null;
    this.quotationService.images.subscribe(images => array = images);
    this.quotationService.waterBottleImage.subscribe(image => img = image);    

    if (img !== '') {
      const reader = new FileReader();

      const block = img.split(';');
      if (block[1] === undefined) {
        this.bottleURL = img;
      } else {
      // Get the content type of the image
      const contentType = block[0].split(':')[1]; // In this case "image/png"
  // get the real base64 content of the file
      const realDatabase64 = block[1].split(',')[1];
      const blob = this.b64toBlob(realDatabase64, contentType);
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
          const base64data = reader.result;
          const src = '' + base64data;
          const obj = {
            srcImage: src,
          };
          this.bottleURL = obj.srcImage;
          this.filesToUpload.push(obj);
        };
      }
    }

    this.utils.getColors().then(colors => {
       const colorCap = colors.filter(element => {
        return element.hex === this.configurationModel.cap_color_hex;
      });
       this.colorCapName = colorCap[0].name;
       const colorBottle = colors.filter(element => {
        return element.hex === this.configurationModel.water_bottle_color_hex;
      });
       this.colorBottleName = colorBottle[0].name;
       const colorValve = colors.filter(element => {
        return element.hex === this.configurationModel.valve_color_hex;
      });
       this.colorValveName = colorValve[0].name;
    }).catch(error => {this.eventService.hideSpinner(); });

    this.userDataService.checkUser().then(user => {
      this.user = user;
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.email = user.email;
      this.configurationModel.user_id = user.id;
      this.eventService.hideSpinner();
    }).catch(error => {
      /* this.firstName = '';
      this.lastName = '';
      this.email = ''; */
      this.eventService.hideSpinner();
    });

    array.forEach(element => {
      this.configurationModel.images.push(element.srcImage);
    });

    this.filesToUpload = array;
  }

  clickCheckbox1() {
    if (this.clickFirst === false) {
      this.clickFirst = true;
    } else {
      this.clickFirst = false;
    }
  }

  clickCheckbox2() {
    if (this.clickSecond === false) {
      this.clickSecond = true;
    } else {
      this.clickSecond = false;
    }
  }

  randomString(length, chars) {
    let result = '';
    for (let i = length; i > 0; --i) { result += chars[Math.floor(Math.random() * chars.length)]; }
    return result;
  }

  sendRequest() {
    this.quotationModel.user_type = this.formIsCompany ? 'C' : 'P';
    this.quotationModel.usage_type = parseInt(this.usage_type, 10);

    let error = '';
    if (this.country === '') {
      error = 'quotation.message_country';
    } else if (this.country === 'IT' && !this.utils.checkITTaxCode(this.quotationModel.fiscal_code)) {
      error = 'quotation.message_invalid_fiscal_code';
    } else if (this.delivery_country === '' && this.quotationModel.different_delivery_address) {
      error = 'quotation.message_delivery_country';
    } else if (this.usage_type === '0') {
      error = 'quotation.message_purpose';
    } else if (!this.disclaimer) {
      error = 'quotation.message_specifications';
    }
    if (error !== '') {
      this.eventService.setTextPopupText(this.translate.instant(error));
      this.eventService.showTextPopup();
      return;
    }

    this.quotationModel.residence_state = null;
    this.quotationModel.delivery_country = null;

    this.countries.forEach(country => {
      if (this.country !== '' && this.country === country.code) {
        this.quotationModel.residence_state = country.name;
      }
      if (this.delivery_country !== '' && this.delivery_country === country.code) {
        this.quotationModel.delivery_country = country.name;
      }
    });

    this.eventService.showSpinner();
    this.quotationModel.code = this.randomString(12, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ');

    if (this.configurationId === undefined) {
      if (this.user === null) {
        this.configurationModel.user_id = 0;
      }
      console.log(this.configurationModel);
      this.configurationsService.uploadConfiguration(this.configurationModel).then(response => {
        this.configurationModel = response;
        this.configurationId =  this.configurationModel.id;
        this.saveImages();
      }).catch(error => {
        this.eventService.hideSpinner();
      });
    } else {
      this.configurationsService.updateConfiguration(this.configurationId).then(response => {
        this.saveQuotation();
      }).catch(error => {
        this.eventService.hideSpinner();
      });
    }
  }

  saveImagesQuotation() {
    if (this.filesToUpload.length === 0) {
      this.quotationService.setCode(this.quotationModel.code);
      if (this.configurationModel.price) {
        this.router.navigate(['/feedback'], { queryParams: { order: 'true' } });
      } else {
        this.router.navigate(['/feedback']);
      }
      return;
    }
    const image = this.filesToUpload[0];
    const block = image.srcImage.split(';');
    let data = {
      area_index: null,
      assetContentType: null,
    };
    if (!image.area_index) {
      data = {
        area_index: 0,
        assetContentType: block[0].split(':')[1],
      };
    } else {
      data = {
        area_index: image.area_index,
        assetContentType: block[0].split(':')[1],
      };
    }

    this.quotationService.uploadQuotationAsset(this.quotationModel.id, data, data.area_index).then((response: any) => {
      this.saveNextImageQuotation(response);
    }).catch(error => {
      this.eventService.hideSpinner();
      console.log(error);
    });
  }

  saveImages() {
    if (this.filesToUpload.length === 0) {
      this.saveQuotation();
      return;
    }
    const image = this.filesToUpload[0];
    const block = image.srcImage.split(';');
    let data = {
      area_index: null,
      assetContentType: null,
    };
    if (!image.area_index) {
      data = {
        area_index: 0,
        assetContentType: block[0].split(':')[1],
      };
    } else {
      data = {
        area_index: image.area_index,
        assetContentType: block[0].split(':')[1],
      };
    }

    this.configurationsService.uploadConfigurationAsset(this.configurationModel.id, data, data.area_index).then((response: any) => {
      this.saveNextImage(response);
    }).catch(error => {
      this.eventService.hideSpinner();
      console.log(error);
    });
  }

  saveNextImageQuotation(response: any) {
    const fileToUpload = this.filesToUpload[0];
    const block = fileToUpload.srcImage.split(';');
// Get the content type of the image
    const contentType = block[0].split(':')[1]; // In this case "image/png"
// get the real base64 content of the file
    const realDatabase64 = block[1].split(',')[1];
    this.utils.uploadFile(response.fileUploadResponse, realDatabase64, contentType).subscribe(() => {
      this.filesToUpload.splice(0, 1);
      this.saveImagesQuotation();
    }, (error: any) => {

    });
  }

  saveNextImage(response: any) {
    const fileToUpload = this.filesToUpload[0];
    const block = fileToUpload.srcImage.split(';');
// Get the content type of the image
    const contentType = block[0].split(':')[1]; // In this case "image/png"
// get the real base64 content of the file
    const realDatabase64 = block[1].split(',')[1];
    this.utils.uploadFile(response.fileUploadResponse, realDatabase64, contentType).subscribe(() => {
      this.filesToUpload.splice(0, 1);
      this.saveImages();
    }, (error: any) => {

    });
  }

  private saveQuotation() {
    this.quotationModel.configuration_id = this.configurationId;
    this.quotationService.uploadQuotation(this.quotationModel).then(response => {
      this.quotationService.setSerial(response.counter);
      this.completeConfiguration();
    }).catch(error => {
      this.eventService.hideSpinner();
      console.log(error);
      return null;
    });
  }

  private completeConfiguration() {
    this.configurationsService.updateConfiguration(this.configurationId).then(response => {
      this.quotationModel.lang = this.translate.instant('lang');
      this.quotationService.postQuotationEmail(this.quotationModel).then(() => {
        this.quotationService.setCode(this.quotationModel.code);
        if (this.configurationModel.price) {
          this.router.navigate(['/feedback'], { queryParams: { order: 'true' } });
        } else {
          this.router.navigate(['/feedback']);
        }
      }).catch(error => {
        this.eventService.hideSpinner();
        console.log(error);
      });
    }).catch(error => {
      this.eventService.hideSpinner();
      console.log(error);
      return null;
    });
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  getOrderPrice(): number {
    return Math.round(this.configurationModel.price * this.configurationModel.quantity * 100) / 100;
  }

  clickCompanyCheckbox() {
    this.formIsCompany = true;
  }

  clickPrivateCheckbox() {
    this.formIsCompany = false;
  }

  clickSameAddressCheckbox() {
    this.quotationModel.different_delivery_address = false;
  }

  clickDifferentAddressCheckbox() {
    this.quotationModel.different_delivery_address = true;
  }

  clickDisclaimerCheckbox() {
    this.disclaimer = !this.disclaimer;
  }

  private getLastQuotation() {
    this.quotationService.getLastQuotation().then(quotation => {
      if (quotation) {
        this.quotationModel.email = quotation.email;
        this.quotationModel.phone_number = quotation.phone_number;
        this.quotationModel.address = quotation.address;
        this.quotationModel.civic_number = quotation.civic_number;
        this.quotationModel.zip_code = quotation.zip_code;
        this.quotationModel.city = quotation.city;
        this.quotationModel.vat_number = quotation.vat_number;
        this.quotationModel.fiscal_code = quotation.fiscal_code;
        this.quotationModel.sdi_code = quotation.sdi_code;
        this.quotationModel.different_delivery_address = quotation.different_delivery_address;
        this.quotationModel.delivery_name = quotation.delivery_name;
        this.quotationModel.delivery_address = quotation.delivery_address;
        this.quotationModel.delivery_civic_number = quotation.delivery_civic_number;
        this.quotationModel.delivery_zip_code = quotation.delivery_zip_code;
        this.quotationModel.delivery_city = quotation.delivery_city;
        this.usage_type = '' + quotation.usage_type;
        this.countries.forEach(country => {
          if (country.name === quotation.residence_state) {
            this.country = country.code;
          }
          if (country.name === quotation.delivery_country) {
            this.delivery_country = country.code;
          }
        });
      }
    });
  }
}
